// @ts-nocheck
// Kopie von services/chat-widget/src/app/components/command-widget/vendor/liquid.js
// (dort aus dem Prototyp design/orbi-command/liquid.js) — für die animierte
// Liquid-Vorschau auf der Interface-Seite. Als .ts, weil das Portal kein allowJs
// hat; Inhalt 1:1, Änderungen im Widget hierher übertragen.

// Kopie von services/chat-widget/design/orbi-command/liquid.js (Prototyp „Orbi Command“).
// Für das Widget nur drei Anpassungen, sonst 1:1 – Änderungen am Prototyp hierher übertragen:
//   1. --oc-gel / --oc-gel-dur landen am Host, nicht am <html> der Kundenseite.
//   2. Blockt die Kundenseite innerHTML (Trusted Types), läuft das Widget ohne Flüssig-Effekt.
//   3. Tropfenfarbe über --oc-goo-fill (SVG kann keinen CSS-Verlauf als fill).
// Flüssiges Teilen/Verschmelzen („Liquid split/merge“) – EIN Bewegungsprinzip für das ganze Widget,
// wie die Knöpfe der Spotlight-Leiste: Apps und Vorschläge drücken sich als Tropfen aus dem Rand der
// Leiste, schnüren sich ab und wabbeln nach; die Canvas wächst als Fläche aus demselben Rand, wabbelt
// beim Ansichtswechsel wie Gel und fließt beim Ausblenden zurück. Alles andere (Nachrichten, Leiste,
// Knopfdruck) nutzt dieselbe Feder – als CSS-Kurve `--oc-gel` bzw. als `jiggle()`.
//
// Technik: Hinter den echten Knöpfen liegt eine SVG-Ebene mit einem „Goo“-Filter (Weichzeichnen +
// Alpha-Schwelle) – Formen, die sich nahe kommen, fließen dort zu einer zusammen. Unter dem Rand der
// Leiste steckt je Gruppe ein verdecktes Reservoir, aus dem der Tropfen herauswächst; ein Nachzieher
// zwischen beiden bildet den Hals, der sich lang zieht und abschnürt. Die Bewegung
// ist eine kleine Feder-Simulation (Position, Größe, Verformung wie ein Gel), vorab in Keyframes
// gerechnet und gleichzeitig auf Knopf und Tropfen gelegt. Während der Animation zeigt der Knopf nur
// seinen Inhalt; die Fläche malt der Tropfen. Danach übernimmt der Knopf wieder ganz.

const NS = "http://www.w3.org/2000/svg";
const FRAME = 1000 / 60;
const INK = "#0f172a";

const RISE = { k: 150, c: 14.5, ks: 170, cs: 12, kd: 420, cd: 6.5, g: 0.7 };
const SINK = { k: 420, c: 41, ks: 380, cs: 39, kd: 420, cd: 9, g: 0.5 };
const S0 = 0.42; // Größe des Tropfens, wenn er noch im Rand steckt
const smooth = (x) => x * x * (3 - 2 * x);
const clamp01 = (x) => Math.max(0, Math.min(1, x));

// Canvas als Fläche: wächst (p 0 → 1) mit leichtem Überschwingen, Gel-Verformung d schwingt nach
const GROW = { k: 120, c: 17, kd: 260, cd: 10, g: 0.08 };
const SHRINK = { k: 300, c: 34.6, kd: 260, cd: 6, g: 0.06 };
// Ansichtswechsel: spürbares Nachgeben mit ein, zwei Nachschwingern (Marcel, 26.10.2026: erst zu viel, dann zu wenig)
const WOBBLE = { k: 230, c: 19, kd: 290, cd: 11 };
const JIGGLE = { kd: 300, cd: 5 };

// Dieselbe Feder als CSS-Kurve (linear()) für alles, was nicht flüssig geteilt wird
function gelCurve() {
  const k = 170, c = 14.3, dt = 1 / 240, pts = [];
  let x = 0, v = 0, t = 0;
  while (t < 1.2) {
    const a = -k * (x - 1) - c * v;
    v += a * dt; x += v * dt; t += dt;
    pts.push(x);
    if (t > 0.3 && Math.abs(x - 1) < 0.002 && Math.abs(v) < 0.02) break;
  }
  const n = 40, step = pts.length / n;
  const vals = [0];
  for (let i = 1; i < n; i++) vals.push(pts[Math.round(i * step) - 1].toFixed(4));
  vals.push(1);
  return { easing: `linear(${vals.join(", ")})`, ms: Math.round(t * 1000) };
}

// Ohne Flüssig-Effekt: Knöpfe und Canvas kommen nur mit ihren CSS-Übergängen
function disabledLiquid() {
  const done = () => Promise.resolve();
  return { enabled: false, rise: done, sink: done, grow: done, shrink: done, wobble: done, jiggle() {}, clear() {}, clearAll() {} };
}

export function createLiquid(host) {
  const svg = document.createElementNS(NS, "svg");
  svg.classList.add("oc-goo");
  svg.setAttribute("aria-hidden", "true");
  try {
    svg.innerHTML = `
      <defs>
        <filter id="ocGoo" x="-60%" y="-60%" width="220%" height="220%" color-interpolation-filters="sRGB">
          <feGaussianBlur in="SourceGraphic" stdDeviation="6"/>
          <feColorMatrix values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 24 -10"/>
          <feDropShadow dy="4" stdDeviation="6" flood-color="${INK}" flood-opacity=".18"/>
        </filter>
        <filter id="ocGooRing" x="-60%" y="-60%" width="220%" height="220%" color-interpolation-filters="sRGB">
          <feGaussianBlur in="SourceGraphic" stdDeviation="6"/>
          <feColorMatrix values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 24 -10" result="goo"/>
          <feMorphology in="goo" operator="erode" radius="1.5" result="inner"/>
          <feFlood style="flood-color: var(--oc-accent-ink)"/>
          <feComposite in2="goo" operator="in" result="ring"/>
          <feMerge result="shape"><feMergeNode in="ring"/><feMergeNode in="inner"/></feMerge>
          <feDropShadow in="shape" dy="4" stdDeviation="6" flood-color="${INK}" flood-opacity=".12"/>
        </filter>
        <!-- Canvas: weiß mit Rand in der Leistenfarbe, Schatten wie die Karte -->
        <filter id="ocGooSurface" x="-15%" y="-15%" width="130%" height="140%" color-interpolation-filters="sRGB">
          <feGaussianBlur in="SourceGraphic" stdDeviation="6"/>
          <feColorMatrix values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 24 -10" result="goo"/>
          <feMorphology in="goo" operator="erode" radius="1.5" result="inner"/>
          <feFlood style="flood-color: var(--oc-rim)"/>
          <feComposite in2="goo" operator="in" result="ring"/>
          <feMerge result="shape"><feMergeNode in="ring"/><feMergeNode in="inner"/></feMerge>
          <feDropShadow in="shape" dy="14" stdDeviation="18" flood-color="${INK}" flood-opacity=".16"/>
        </filter>
      </defs>`;
  } catch {
    return disabledLiquid();
  }
  host.prepend(svg);
  const gel = gelCurve();
  host.style.setProperty("--oc-gel", gel.easing);
  host.style.setProperty("--oc-gel-dur", `${gel.ms}ms`);

  const reduced = matchMedia("(prefers-reduced-motion: reduce)");
  const tracks = new Map(); // Knopf → { anim, blobAnim, blob, samples, group, rest, dir }
  const groups = new Map(); // Gruppenname → { g, reservoir, count }

  const timeScale = () => (parseFloat(getComputedStyle(host).getPropertyValue("--oc-dur")) || 560) / 560;

  // Lage eines Knopfs ohne Transform, in Koordinaten der SVG-Ebene (Unterkante = Rand der Leiste)
  function restRect(el) {
    let x = 0, y = 0, n = el;
    while (n && n !== host) { x += n.offsetLeft; y += n.offsetTop; n = n.offsetParent; }
    const h = host.getBoundingClientRect(), s = svg.getBoundingClientRect();
    x -= s.left - h.left;
    y -= s.top - h.top;
    return { x, y, w: el.offsetWidth, h: el.offsetHeight, H: s.height };
  }

  // kind: "ink" (dunkle Knöpfe), "ring" (weiß mit Rand), "surface" (Canvas)
  function group(name, kind) {
    let gr = groups.get(name);
    if (gr) return gr;
    const g = document.createElementNS(NS, "g");
    g.setAttribute("filter", { ink: "url(#ocGoo)", ring: "url(#ocGooRing)", surface: "url(#ocGooSurface)" }[kind]);
    // Farben aus den Widget-Tokens, damit die Tropfen dem Schalter „Farbe“ folgen
    g.style.fill = kind === "ink" ? "var(--oc-goo-fill, var(--oc-app-bg))" : "#fff";
    const reservoir = document.createElementNS(NS, "rect");
    g.appendChild(reservoir);
    svg.appendChild(g);
    gr = { g, reservoir, count: 0 };
    groups.set(name, gr);
    return gr;
  }

  // Verdecktes Reservoir knapp unter dem Rand, etwas breiter als der Hals
  function placeReservoir(gr, r) {
    const w = Math.max(Math.min(r.w, r.h) * 0.9, Math.min(r.w * 0.44, r.h * 1.7)) + 6;
    const res = gr.reservoir;
    res.setAttribute("x", r.x + r.w / 2 - w / 2);
    res.setAttribute("y", r.H + 2);
    res.setAttribute("width", w);
    res.setAttribute("height", 28);
    res.setAttribute("rx", 12);
  }

  // Aktueller Zustand eines Knopfs – läuft schon eine Animation, wird dort weitergemacht
  function stateOf(el, fallback) {
    const t = tracks.get(el);
    if (!t) return { ...fallback };
    const time = t.anim.currentTime ?? 0;
    const i = Math.max(0, Math.min(t.samples.length - 1, Math.floor((time - t.delay) / t.frame)));
    return time < t.delay ? { ...t.samples[0] } : { ...t.samples[i] };
  }

  // Feder-Simulation: Position u, Größe s, Gel-Verformung d (aus der Beschleunigung) und ein
  // Nachzieher (Hals), der zwischen Tropfen und Reservoir hängt, sich lang zieht und abschnürt.
  function simulate(st, target, P, r, dir) {
    const out = [];
    const dt = 1 / 240;
    const rim = r.H;
    const cy0 = r.y + r.h / 2;
    const rT = Math.min(r.w, r.h) * 0.34;
    const hidden = rim + rT + 3;
    let { u, v, s, vs, d, vd, op } = st;
    let yt = st.tu == null ? hidden : cy0 + st.tu;
    let vt = st.vt || 0;
    let released = dir === "sink" ? false : st.tu != null && st.released;
    const u0 = u;
    const U = Math.max(Math.abs(target.u - u), 40);
    const op0 = op;
    let t = 0, next = 0;
    const maxT = dir === "sink" ? 0.7 : 2.6; // Sicherung: zurücksinken darf nie hängen bleiben
    for (let step = 0; step < 240 * maxT; step++) {
      // beim Herausdrücken zieht das Ziel erst sanft an – sonst schösse der Tropfen sofort los
      const tu = dir === "rise" ? target.u + (u0 - target.u) * (1 - smooth(Math.min(1, t / 0.13))) : target.u;
      const a = -P.k * (u - tu) - P.c * v;
      const as = -P.ks * (s - target.s) - P.cs * vs;
      const ad = -P.kd * d - P.cd * vd - (P.g * a) / U;
      v += a * dt; u += v * dt;
      vs += as * dt; s += vs * dt;
      vd += ad * dt; d += vd * dt;
      d = Math.max(-0.35, Math.min(0.45, d));

      const bottom = cy0 + u + (s * r.h * (1 + d)) / 2;
      let yTarget;
      if (dir === "rise") {
        // der Hals reißt, sobald der Tropfen gut die Hälfte seines Ruheabstands zum Rand geschafft hat
        if (!released && rim - bottom > Math.min(r.h * 0.45 + 8, (rim - r.y - r.h) * 0.55)) released = true;
        yTarget = released ? hidden : Math.max(bottom - rT * 0.7, rim - r.h * 0.9);
      } else {
        // beim Zurücksinken greift die Leiste nach dem Tropfen – bis er im Rand verschwunden ist
        const top = cy0 + u - (s * r.h * (1 + d)) / 2;
        yTarget = top > rim ? hidden : Math.min(hidden, Math.max(bottom - rT * 0.7, rim - r.h * 0.5));
      }
      const kt = released ? 260 : 520, ct = released ? 24 : 26;
      vt += (-kt * (yt - yTarget) - ct * vt) * dt;
      yt += vt * dt;
      t += dt;

      if (dir === "rise") {
        // Inhalt erscheint erst, wenn sich der Tropfen vom Rand und von den Nachbarn gelöst hat
        const p = 1 - (u - target.u) / ((u0 - target.u) || 1);
        op = Math.max(op, Math.min(1, Math.max(0, (rim - bottom - 6) / 14), Math.max(0, (p - 0.72) / 0.2)));
      } else {
        op = op0 * Math.max(0, 1 - t / 0.09);
      }
      if (t >= next) { out.push({ u, v, s, vs, d, vd, op, tu: yt - cy0, vt, released }); next += 1 / 60; }
      const tetherIn = yt - rT > rim + 1;
      if (dir === "sink" && cy0 + u - (s * r.h * (1 + Math.abs(d))) / 2 > rim + 2 && tetherIn) break;
      if (dir === "rise" && t > 0.35 && tetherIn && Math.abs(u) < 0.25 && Math.abs(v) < 4 && Math.abs(d) < 0.004 &&
          Math.abs(vd) < 0.08 && Math.abs(s - 1) < 0.003 && Math.abs(vs) < 0.05) break;
    }
    const last = out[out.length - 1];
    out.push(dir === "rise" ? { ...last, u: 0, v: 0, s: 1, vs: 0, d: 0, vd: 0, op: 1 } : { ...last, op: 0 });
    return out;
  }

  const xf = (p) => `translate(0px, ${p.u.toFixed(2)}px) scale(${(p.s * (1 - 0.55 * p.d)).toFixed(4)}, ${(p.s * (1 + p.d)).toFixed(4)})`;

  function stop(el) {
    const t = tracks.get(el);
    if (!t) return;
    [t.anim, t.blobAnim, t.tetherAnim].forEach((a) => a?.cancel());
    t.blob.remove();
    t.tether?.remove();
    tracks.delete(el);
    release(t.group);
  }

  function release(name) {
    const gr = groups.get(name);
    if (!gr || --gr.count > 0) return;
    gr.g.remove();
    groups.delete(name);
  }

  // Knopf übernimmt seine Fläche sofort wieder (ohne Farbübergang), Tropfen weg – im selben Frame
  function settle(el) {
    const prev = el.style.transition;
    el.style.transition = "none";
    el.classList.remove("is-liquid");
    void el.offsetWidth;
    el.style.transition = prev;
  }

  function run(items, dir) {
    if (!items.length) return Promise.resolve();
    const ts = timeScale();
    items.forEach(({ el }) => el.classList.add("is-liquid")); // vor dem Messen: keine CSS-Übergänge
    return Promise.all(items.map(({ el, group: name, delay = 0 }) => {
      // noch gar nicht aufgetaucht (wartet auf seinen Einsatz) – nichts zurückzuziehen
      const pending = tracks.get(el);
      if (dir === "sink" && pending && (pending.anim.currentTime ?? 0) < pending.delay) {
        stop(el);
        settle(el);
        return Promise.resolve();
      }
      const r = restRect(el);
      // ganz im Rand versenkt: Oberkante 8px unter der Kante, damit das Absinken sicher endet
      const sunkU = r.H + S0 * r.h / 2 + 8 - (r.y + r.h / 2);
      const from = stateOf(el, dir === "rise"
        ? { u: sunkU, v: 0, s: S0, vs: 0, d: 0, vd: 0, op: 0, tu: null }
        : { u: 0, v: 0, s: 1, vs: 0, d: 0, vd: 0, op: 1 });
      stop(el);
      el.classList.add("is-liquid");

      const gr = group(name, el.matches(".oc-chip--more, .oc-chip--resume") ? "ring" : "ink");
      gr.count++;
      placeReservoir(gr, r);
      const blob = document.createElementNS(NS, "rect");
      blob.setAttribute("x", r.x);
      blob.setAttribute("y", r.y);
      blob.setAttribute("width", r.w);
      blob.setAttribute("height", r.h);
      blob.setAttribute("rx", Math.min(r.w, r.h) / 2);
      gr.g.appendChild(blob);
      const rT = Math.min(r.w, r.h) * 0.34;
      // bei breiten Vorschlägen ein breiterer Hals, bei runden Apps ein Kreis
      const tether = document.createElementNS(NS, "ellipse");
      tether.setAttribute("cx", r.x + r.w / 2);
      tether.setAttribute("cy", r.y + r.h / 2);
      tether.setAttribute("rx", Math.max(rT, Math.min(r.w * 0.22, r.h * 0.85)));
      tether.setAttribute("ry", rT);
      gr.g.appendChild(tether);

      const target = dir === "rise" ? { u: 0, s: 1 } : { u: sunkU, s: S0 };
      const samples = simulate(from, target, dir === "rise" ? RISE : SINK, r, dir);
      const frame = FRAME * ts;
      const timing = { duration: samples.length * frame, delay: delay * ts, easing: "linear", fill: "backwards" };
      const anim = el.animate(samples.map((p) => ({ transform: xf(p), opacity: p.op })), timing);
      // Tropfen halten ihr letztes Bild, bis sie entfernt sind – sonst blitzen sie einen Frame an der Ruhelage auf
      const shapeTiming = { ...timing, fill: "both" };
      const blobAnim = blob.animate(samples.map((p) => ({ transform: xf(p) })), shapeTiming);
      const tetherAnim = tether.animate(samples.map((p) => ({ transform: `translate(0px, ${p.tu.toFixed(2)}px)` })), shapeTiming);
      const track = { anim, blobAnim, tetherAnim, blob, tether, samples, group: name, delay: delay * ts, frame };
      tracks.set(el, track);

      return anim.finished.then(() => {
        if (tracks.get(el) !== track) return;
        tracks.delete(el);
        blob.remove();
        tether.remove();
        settle(el);
        release(name);
      }, () => {});
    }));
  }

  // --- Fläche (Canvas) ------------------------------------------------------
  // Unterkante wandert vom Rand (verdeckt) an ihren Platz, Höhe wächst mit p, Breite von halb auf voll;
  // ein breiter Hals hängt an der Leiste, bis sich die Fläche gelöst hat.
  function simulateSurface(st, mode, r) {
    const out = [];
    const dt = 1 / 240;
    const rim = r.H;
    const gap = rim - (r.y + r.h);
    const lift = gap + 6;
    const ry = 12;
    const hidden = rim + ry + 3;
    const P = { grow: GROW, shrink: SHRINK, wobble: WOBBLE }[mode];
    let { p, vp, d, vd, op } = st;
    let yt = st.tu == null ? hidden : r.y + r.h + st.tu;
    let vt = st.vt || 0;
    let released = mode !== "grow" || st.released;
    const p0 = p, op0 = op;
    let t = 0, next = 0;
    const maxT = mode === "shrink" ? 0.7 : 2;
    for (let step = 0; step < 240 * maxT; step++) {
      const pt = mode === "grow" ? p0 + (1 - p0) * smooth(Math.min(1, t / 0.13)) : mode === "shrink" ? 0 : 1;
      const ap = -P.k * (p - pt) - P.c * vp;
      const ad = -P.kd * d - P.cd * vd - (P.g || 0) * ap;
      vp += ap * dt; p += vp * dt;
      vd += ad * dt; d += vd * dt;
      d = Math.max(-0.12, Math.min(0.12, d));

      const bottom = r.y + r.h + (1 - p) * lift;
      const top = bottom - r.h * Math.max(p, 0) * (1 + d);
      let yTarget = hidden;
      if (mode === "grow") {
        if (!released && rim - bottom > gap * 0.6) released = true;
        if (!released) yTarget = Math.max(bottom - ry * 0.6, rim - gap - 6);
      } else if (mode === "shrink" && top < rim) {
        yTarget = Math.min(hidden, Math.max(bottom - ry * 0.6, rim - gap));
      }
      const kt = released ? 260 : 520, ct = released ? 24 : 26;
      vt += (-kt * (yt - yTarget) - ct * vt) * dt;
      yt += vt * dt;
      t += dt;

      if (mode === "grow") op = Math.max(op, clamp01((p - 0.8) / 0.17));
      else if (mode === "shrink") op = op0 * Math.max(0, 1 - t / 0.08);
      if (t >= next) { out.push({ p, vp, d, vd, op, tu: yt - (r.y + r.h), vt, released, lift }); next += 1 / 60; }
      const tetherIn = yt - ry > rim + 1;
      if (mode === "shrink" && p < 0.02 && tetherIn) break;
      if (mode !== "shrink" && t > 0.4 && tetherIn && Math.abs(p - 1) < 0.002 && Math.abs(vp) < 0.03 &&
          Math.abs(d) < 0.003 && Math.abs(vd) < 0.05) break;
    }
    const last = out[out.length - 1];
    out.push(mode === "shrink" ? { ...last, p: 0, op: 0 } : { ...last, p: 1, vp: 0, d: 0, vd: 0, op: 1 });
    return out;
  }

  const sxf = (q) => `translate(0px, ${((1 - q.p) * q.lift).toFixed(2)}px) scale(${((0.5 + 0.5 * q.p) * (1 - 0.5 * q.d)).toFixed(4)}, ${(Math.max(q.p, 0.0005) * (1 + q.d)).toFixed(4)})`;

  function surface(el, mode, delay = 0) {
    const running = tracks.get(el);
    // Wabbeln nur auf einer ruhenden Fläche – wächst oder schrumpft sie gerade, reicht das
    if (mode === "wobble" && running) return Promise.resolve();
    if (mode === "shrink" && running && (running.anim.currentTime ?? 0) < running.delay) {
      stop(el);
      settle(el);
      return Promise.resolve();
    }
    const ts = timeScale();
    el.classList.add("is-liquid");
    const r = restRect(el);
    const rest = { p: 1, vp: 0, d: 0, vd: 0, op: 1, tu: null };
    const from = stateOf(el, mode === "grow" ? { p: 0, vp: 0, d: 0, vd: 0, op: 0, tu: null } : rest);
    if (mode === "wobble") { from.vp = -0.2; from.vd = -0.8; }
    stop(el);
    el.classList.add("is-liquid");

    const name = "surface";
    const gr = group(name, "surface");
    gr.count++;
    const resW = Math.min(r.w * 0.4, 180);
    const res = gr.reservoir;
    res.setAttribute("x", r.x + r.w / 2 - resW / 2);
    res.setAttribute("y", r.H + 2);
    res.setAttribute("width", resW);
    res.setAttribute("height", 30);
    res.setAttribute("rx", 14);
    const blob = document.createElementNS(NS, "rect");
    blob.setAttribute("x", r.x);
    blob.setAttribute("y", r.y);
    blob.setAttribute("width", r.w);
    blob.setAttribute("height", r.h);
    blob.setAttribute("rx", parseFloat(getComputedStyle(el).borderTopLeftRadius) || 22);
    blob.style.transformOrigin = "50% 100%";
    gr.g.appendChild(blob);
    const tether = document.createElementNS(NS, "ellipse");
    tether.setAttribute("cx", r.x + r.w / 2);
    tether.setAttribute("cy", r.y + r.h);
    tether.setAttribute("rx", Math.min(r.w * 0.16, 70));
    tether.setAttribute("ry", 12);
    gr.g.appendChild(tether);

    const samples = simulateSurface(from, mode, r);
    const frame = FRAME * ts;
    const timing = { duration: samples.length * frame, delay: delay * ts, easing: "linear", fill: "backwards" };
    const shapeTiming = { ...timing, fill: "both" };
    // Wabbeln nimmt den Inhalt mit (Gel), Wachsen/Schrumpfen blendet ihn nur ein bzw. aus
    const anim = el.animate(samples.map((q) => (mode === "wobble" ? { transform: sxf(q) } : { opacity: q.op })), timing);
    const blobAnim = blob.animate(samples.map((q) => ({ transform: sxf(q) })), shapeTiming);
    const tetherAnim = tether.animate(samples.map((q) => ({ transform: `translate(0px, ${q.tu.toFixed(2)}px)` })), shapeTiming);
    const track = { anim, blobAnim, tetherAnim, blob, tether, samples, group: name, delay: delay * ts, frame };
    tracks.set(el, track);
    return anim.finished.then(() => {
      if (tracks.get(el) !== track) return;
      tracks.delete(el);
      blob.remove();
      tether.remove();
      settle(el);
      release(name);
    }, () => {});
  }

  // Gel-Nachschwingen ohne Goo-Ebene: Leiste, Knopfdruck. kick > 0 dehnt zuerst entlang axis.
  function jiggle(el, { axis = "y", kick = 0.8, origin = "50% 50%" } = {}) {
    if (reduced.matches || tracks.has(el)) return;
    const frames = [];
    const dt = 1 / 240;
    let d = 0, vd = kick, t = 0, next = 0;
    while (t < 1.2) {
      const ad = -JIGGLE.kd * d - JIGGLE.cd * vd;
      vd += ad * dt; d += vd * dt; t += dt;
      if (t >= next) {
        const a = (1 + d).toFixed(4), b = (1 - 0.6 * d).toFixed(4);
        frames.push({ transform: axis === "x" ? `scale(${a}, ${b})` : `scale(${b}, ${a})` });
        next += 1 / 60;
      }
      if (t > 0.2 && Math.abs(d) < 0.0015 && Math.abs(vd) < 0.03) break;
    }
    frames.push({ transform: "none" });
    const prev = el.style.transformOrigin;
    el.style.transformOrigin = origin;
    el.animate(frames, { duration: frames.length * FRAME, easing: "linear", composite: "add" })
      .finished.then(() => (el.style.transformOrigin = prev), () => {});
  }

  return {
    get enabled() { return !reduced.matches; },
    rise: (items) => run(items, "rise"),
    sink: (items) => run(items, "sink"),
    grow: (el, delay) => surface(el, "grow", delay),
    shrink: (el) => surface(el, "shrink"),
    wobble: (el) => surface(el, "wobble"),
    jiggle,
    // Knöpfe, die gleich aus dem DOM fliegen oder in einem anderen Layout stehen
    clear(els) {
      els.forEach((el) => { stop(el); settle(el); });
    },
    clearAll() {
      [...tracks.keys()].forEach((el) => { stop(el); settle(el); });
    },
  };
}
